<template>
  <div
    id="air_pullution"
    style="position: relative"
    :style="{
      height: '100%',
      'border-radius': '50px 50px 30px 30px',
      background: imglist.bg,
    }"
  >
    <div
      class="div-row al-center"
      :style="{ 'border-radius': '50px', background: imglist.head }"
    >
      <div
        :style="{
          width: '35%',
          'border-radius': '50%',
          background: imglist.cr,
        }"
      >
        <img width="100%" style="border-radius: 50%" :src="imgGift1" />
      </div>

      <div style="width: 65%; text-align: center">
        <h2 class="headCardTe">{{ head }}</h2>
      </div>
    </div>
    <div style="text-align: center; position: absolute; width: 100%">
      <div class="ml-55">
        <h2
          style="font-weight: 600"
          v-if="head === 'TVOCs'"
          class="textSpansub mt-3"
        >
          ppm
        </h2>
        <h2
          style="font-weight: 600"
          v-if="head === 'PM2.5'"
          class="textSpansub mt-3"
        >
          µg/m <sup>3</sup>
        </h2>
        <h2
          style="font-weight: 600"
          v-if="head === 'PM10'"
          class="textSpansub mt-3"
        >
          mg/m <sup>3</sup>
        </h2>
      </div>
      <div class="div-row mt-1 al-center">
         <h1  v-if="head === 'PM10'" class="text_value" :style="{ color: imglist.color }">
          {{ value.toFixed(2) }}
        </h1>
        <h1 v-else class="text_value" :style="{ color: imglist.color }">
          {{ value }}
        </h1>
      </div>
    </div>
    <div
      style="
        text-align: center;
        width: 100%;
        bottom: 0px;
        height: 80px;
        align-items: center;
        position: absolute;
      "
      class="div-row al-center mb-1"
    >
      <h6 style="font-weight: 600" class="thFontthai text_detail_th ml-1 mr-1">
        {{ detail }}
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  props: ["head", "detail", "imgGift1", "imglist", "value"],
};
</script>

<style lang="scss" scoped>
@import "./../aqi.scss";
.div-row {
  display: flex;
  justify-content: center;
}
.roundedCardGreen-header {
  background: rgba(98, 201, 147, 0.9);
  border-radius: 50px;
  //   height: 60px;
}

.ml-55 {
  margin-left: 55%;
}
:fullscreen {
  .ml-55 {
    margin-left: 68%;
  }
  .text_detail_th {
    font-size: 1vw;
    // margin-top: 20px;
  }
}
</style>